__turbopack_context__.v({
  "grid": "object-grid-module-scss-module__u_wwzq__grid",
});
